import { render, staticRenderFns } from "./SourceOrTargetItem.vue?vue&type=template&id=6413e65c&scoped=true&"
import script from "./SourceOrTargetItem.vue?vue&type=script&lang=js&"
export * from "./SourceOrTargetItem.vue?vue&type=script&lang=js&"
import style0 from "./SourceOrTargetItem.css?vue&type=style&index=0&id=6413e65c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6413e65c",
  null
  
)

export default component.exports